import head from 'lodash/head';
import orderBy from 'lodash/orderBy';
import { EMBARGO_EXTERNAL_ATTR, INRIVER_ID, POPULARITY_INDEX_ATTR } from '@yme/common/constants';
import { getAttributeByName } from '@yme/utils/common';
import { QUERY_SEPARATOR } from '@yme/utils/constants';
import { getVariantWithAvailableLowestPrise } from '@yme/utils/product';
export const buildUrl = (url, query) => Array.isArray(query) ? `${url}${query.join(QUERY_SEPARATOR)}` : '';
export const isEmptyPartsAccessoriesSection = () => true;
export const getPrioritizedAccessories = (arr = [], count) => {
    if (!arr.length) {
        return [];
    }
    const result = arr.slice(0, count) || [];
    return result;
};
export const chooseAccessoryImage = (image, isImageLoading) => {
    if (image.length > 0 && isImageLoading) {
        return image[0].url;
    }
    return '';
};
export function getMasterAccessoriesList(data) {
    const preparedData = data?.map((product) => {
        const { variants, categories, slug } = product;
        const masterVariant = variants.find((variant) => Boolean(variant.master));
        const name = product?.name;
        const { variantWithLowestPrice, isLowestPriseExist } = getVariantWithAvailableLowestPrise({
            product,
        });
        const sku = variantWithLowestPrice?.sku || masterVariant?.sku || '';
        const price = head(variantWithLowestPrice?.prices);
        const stock = variantWithLowestPrice?.stock;
        const discount = price?.discount;
        const embargoExternal = variantWithLowestPrice?.attributes.find((attribute) => attribute.name === EMBARGO_EXTERNAL_ATTR)?.value || '';
        const attributes = variantWithLowestPrice?.attributes;
        const popularityIndex = attributes && getAttributeByName(attributes, POPULARITY_INDEX_ATTR);
        const key = attributes && getAttributeByName(attributes, INRIVER_ID);
        return {
            key,
            name,
            images: variantWithLowestPrice?.images || [],
            discount,
            price,
            categories,
            slug,
            stock,
            popularityIndex,
            sku,
            embargoExternal: Date.parse(embargoExternal),
            isLowestPriseExist,
        };
    });
    return orderBy(preparedData, ['popularityIndex', 'embargoExternal'], ['desc', 'desc']);
}
